/**
 * EcosystemStatsBlock: `ecosystem-stats` DYNAMIC content block.
 *
 * data: { hiddenSections?: string[] } — values among 'stats', 'heatmap',
 * 'charts', 'gaps'; each names a section of EcosystemAnalytics the author
 * has opted to hide on this page.
 *
 * A thin wrapper around the existing EcosystemAnalytics feature component
 * (client/src/features/ecosystem/components/EcosystemAnalytics.jsx): the
 * "Insights" analytics dashboard (sector / region distribution,
 * cross-sector collaboration heatmap, gap analysis). It fetches its own
 * tenant-scoped data via the graph + organization APIs, so this block adds no
 * fetching of its own.
 *
 * NOTE: there is no separate lightweight "ecosystem stats" component;
 * EcosystemAnalytics is the existing reusable tenant-scoped ecosystem-stats
 * component, so this block wraps it rather than reimplementing a stats strip.
 */
import React from 'react';
import PropTypes from 'prop-types';

import EcosystemAnalytics from '@/features/ecosystem/components/EcosystemAnalytics';

export default function EcosystemStatsBlock({ data }) {
    return <EcosystemAnalytics hiddenSections={data.hiddenSections} />;
}

EcosystemStatsBlock.propTypes = {
    data: PropTypes.shape({
        hiddenSections: PropTypes.arrayOf(PropTypes.string),
    }),
};

EcosystemStatsBlock.defaultProps = {
    data: {},
};
